<template lang="pug">
  .component-create-plan
    .row
      .columns
        plan-setup(:create="true")

</template>
<script type="text/babel">
  import PlanSetup from "../../components/backoffice/tabbed/PlanSetup.vue";

  export default {
    name: "CreatePlan",
    components: {PlanSetup},
    data() {
      return {}
    },
    computed: {},
    mounted() {
    },
    created() {

    },
    methods: {},
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreatePlan.vue?9bf18306